export const normalizeName = (value = '') => (value || '').replace(/[0-9]/g, '');

export const normalizePhone = (value = '') => (value || '').replace(/[^0-9]/g, '').substring(0, 10);

export const formatPhone = (value = '') => (value || '').replace(/^(\d{3})(\d{3})(\d{4})$/, '($1) $2-$3');

export const normalizeZip = (value = '') => (value || '').replace(/[^0-9]/g, '').substring(0, 5);

export const formatZip = (value = '') => value;

export const required = (value = '') => (value || '').trim() !== '';

export const isValidPhone = (value = '') => /^$|[01]?[- .]?(?:\(([2-9]\d{2})\)|([2-9]\d{2}))[- .]?(\d{3})[- .]?(\d{4})/.test(value);

export const isValidEmail = (value = '') => /^([a-zA-Z0-9_\-.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/.test(value);

export const isValidZip = (value = '') => /^[0-9]{5}(?:-[0-9]{4})?$/.test(value);

export const isValidName = (value = '') => !/[^a-zA-Z\s'-:]/.test(value);
